module.exports = __webpack_public_path__ + "static/media/Upload__Icon--video.8ef8f235.svg";